module.exports = __webpack_public_path__ + "img/new-dms-quickview.8a2d8b8a.png";